(function ($) {
    $.fn.select2ajax = function (searchUrl, placeholder, maximumSelectionLength, containerCssClass, dropdownCssClass) {
        maximumSelectionLength = maximumSelectionLength || 0;
        containerCssClass = containerCssClass || "";
        dropdownCssClass = dropdownCssClass || "";
        return $(this).select2({
            width: "100%",
            language: "ru",
            placeholder: placeholder ? placeholder : null,
            ajax: {
                url: searchUrl,
                dataType: "json",
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term, // search term
                    };
                },
                processResults: function (data, params) {
                    return {
                        results: data
                    };
                },
                initSelection: function (element, callback) {
                    $.ajax(searchUrl, {
                        dataType: "json"
                    }).done(function (data) {
                        callback(data.addresses[0]);
                    });
                },
                cache: true,
                allowClear: true,
            },
            maximumSelectionLength: maximumSelectionLength,
            minimumInputLength: 1,
            containerCssClass: containerCssClass,
            dropdownCssClass: dropdownCssClass,
        }).on("select2:open", function () {
            $('.select2-results__options').niceScroll({
                cursorwidth: 6,
                cursoropacitymin: 1,
                cursorcolor: '#959595',
                cursorborder: 'none',
                cursorborderradius: 4,
                autohidemode: 'false',
                directionlockdeadzone: 6,
            });
        });
    };
})(jQuery);

$(document).ready(function () {
//select2 поиск города
    $('.js-search-city').select2ajax(
        "/catalog/searchcity",
        'Город',
        0,
        'city_select2',
        'city_select2_dropdown');
    $('.js-search-country').select2({
        width: "100%",
        language: "ru",
        placeholder: 'Страна',
        containerCssClass: 'city_select2',
        dropdownCssClass: 'city_select2_dropdown',
    }).on("select2:open", function () {
        $('.select2-results__options').niceScroll({
            cursorwidth: 6,
            cursoropacitymin: 1,
            cursorcolor: '#959595',
            cursorborder: 'none',
            cursorborderradius: 4,
            autohidemode: 'false',
            directionlockdeadzone: 6,
        });
    });

//select2 поиск товара
    $('.searchItem').select2ajax("/catalog/finditem",
        "Модель",
        0,
        'select2-no-borders',
        'select2-no-borders');
});